// frontend/src/api/timeline.ts
import { api } from "./client";

export interface TimelineLeak {
  _id: string;
  title: string | null;
  forum: string;
  severity: string | null;
  sectors: string[] | null;
  created_at: string;
}

export interface TimelineDay {
  date: string;
  count: number;
  leaks: TimelineLeak[];
}

export interface TimelineResponse {
  timeline: TimelineDay[];
}

export interface TimelineParams {
  days?: number;
  forum?: string;
  sector?: string;
  start_date?: string;
  end_date?: string;
}

export async function getLeakTimeline(
  params: TimelineParams = {}
): Promise<TimelineResponse> {
  const res = await api.get("/leaks/timeline", { params });
  return res.data;
}
